import { render, staticRenderFns } from "./WorksList.vue?vue&type=template&id=fc34d864&scoped=true&"
import script from "./WorksList.vue?vue&type=script&lang=js&"
export * from "./WorksList.vue?vue&type=script&lang=js&"
import style0 from "./WorksList.vue?vue&type=style&index=0&id=fc34d864&lang=scss&scoped=true&"
import style1 from "./WorksList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc34d864",
  null
  
)

export default component.exports